import type React from "react";

import type { ModalBaseProps } from "@/components/Modal/Modal";
import type { SupportedDeepLinkEntityType } from "@/helpers/deep-link";
import { useSessionUser } from "@/hooks/Network/useSessionUser";

import { AdminShareToCommunityFeedModal } from "./AdminShareToCommunityFeedModal";
import { ResidentShareToCommunityFeedModal } from "./ResidentShareToCommunityFeedModal";

type ShareToCommunityFeedModalProps = ModalBaseProps & {
  entityId: string;
  entityType: SupportedDeepLinkEntityType;
  otherIds?: Record<string, string>;
};

export function ShareToCommunityFeedModal({
  entityId,
  entityType,
  otherIds,
  ...modalProps
}: ShareToCommunityFeedModalProps): React.ReactNode {
  const sessionUser = useSessionUser();

  if (sessionUser.isAdmin) {
    return (
      <AdminShareToCommunityFeedModal entityType={entityType} entityId={entityId} otherIds={otherIds} {...modalProps} />
    );
  }

  return (
    <ResidentShareToCommunityFeedModal
      entityType={entityType}
      entityId={entityId}
      otherIds={otherIds}
      {...modalProps}
    />
  );
}
